import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { sanitizeString } from '@sm/utils';
import { Container, Typography } from '@sm/wds-react';
import { createSurveyStyles } from '@sm/webassets';
import './enterprise-thank-you-body.scss';

const useStyles = createSurveyStyles(theme => {
  return {
    bodyTextTheming: {
      color: theme?.questionColor,
      fontFamily: theme?.questionTitle?.fontFamily,
    },
  };
});

const EnterpriseThankYouBody = props => {
  const { premium, bodyImageUrl, bodyText, bodyImageRedirectUrl, endPageIsEnabled } = props;
  const [imageLoadSuccess, setImageLoadSuccess] = useState(true);
  const { bodyTextTheming } = useStyles();

  const redirectUrl = () => {
    window.open(bodyImageRedirectUrl, '_blank');
  };

  const renderBodyText = () => {
    return (
      <If condition={bodyText}>
        <Container className="sm-enterprise-thank-you-body__text" flex flexJustify="center">
          <Typography
            className={`${bodyTextTheming} sm-enterprise-thank-you-body__text-inner`}
            component="h1"
            align="center"
            color="dark"
            dangerouslySetInnerHTML={{ __html: sanitizeString(bodyText) }} // eslint-disable-line jam3/no-sanitizer-with-danger
          />
        </Container>
      </If>
    );
  };

  const renderBodyImage = () => {
    return (
      <Choose>
        <When condition={bodyImageUrl && imageLoadSuccess}>
          <Container className="sm-enterprise-thank-you-body__image" flex flexJustify="center">
            <a
              role="img"
              rel="nofollow"
              target="_blank"
              {...(bodyImageRedirectUrl ? { href: bodyImageRedirectUrl } : {})}
            >
              <img
                data-testid="body__Image"
                className={`sm-enterprise-thank-you-body__inner-image ${
                  bodyImageRedirectUrl
                    ? 'sm-enterprise-thank-you-body__cursor-pointer'
                    : 'sm-enterprise-thank-you-body__cursor-non-pointer'
                }`}
                src={bodyImageUrl}
                alt=""
                onError={() => setImageLoadSuccess(false)}
              />
            </a>
          </Container>
        </When>
        {/* For the case where the image doesn't load, but there needs to be a redirect URL, we just display the URL by itself */}
        <When condition={bodyImageRedirectUrl && !imageLoadSuccess}>
          <Container className="sm-enterprise-thank-you-body__image-redirect-text" flex flexJustify="center">
            <Typography
              className={`${bodyTextTheming} sm-enterprise-thank-you-body__redirect-text sm-enterprise-thank-you-body__cursor-pointer`}
              component="h1"
              align="center"
              color="dark"
              onClick={redirectUrl}
              onKeyPress={redirectUrl}
            >
              {bodyImageRedirectUrl}
            </Typography>
          </Container>
        </When>
      </Choose>
    );
  };

  return (
    <If condition={premium && endPageIsEnabled}>
      <Container className="sm-enterprise-thank-you__body-outline">
        {renderBodyText()}
        {renderBodyImage()}
      </Container>
    </If>
  );
};

EnterpriseThankYouBody.propTypes = {
  premium: PropTypes.bool.isRequired,
  bodyImageUrl: PropTypes.string,
  bodyText: PropTypes.string,
  bodyImageRedirectUrl: PropTypes.string,
  endPageIsEnabled: PropTypes.bool,
};

EnterpriseThankYouBody.defaultProps = {
  bodyImageUrl: null,
  bodyText: null,
  bodyImageRedirectUrl: null,
  endPageIsEnabled: false,
};

export default EnterpriseThankYouBody;
